<template>
	<div class="item" :data-school="school" :job-id="school.jobId" :data-value="school.jobId">
		<div class="ui small header">
			<div class="content">
				{{ jobName }}
				<div class="sub header">{{ orgName }}</div>
			</div>
		</div>
	</div>
</template>

<script>
const DOUBLE_WHITE_SPACE_REGEX = /\s\s+/g;

export default {
	props: ['school'],
	computed: {
		jobName: function() {
			var jobName = this.school.jobName ?? '';
			if(this.school.compositeName) {
				jobName += ' - ' + this.school.compositeName;
			}
			if(this.school.jobShortCode) {
				jobName += ' - ' + this.school.jobShortCode;
			}

			return jobName.replace(DOUBLE_WHITE_SPACE_REGEX, ' ');
		},
		orgName: function() {
			var organizationName = this.school.organizationName ?? '';
			if(this.school.organizationShortCode) {
				organizationName += ' - ' + this.school.organizationShortCode;
			}

			return organizationName.replace(DOUBLE_WHITE_SPACE_REGEX, ' ');
		}
	}
};
</script>

<style scoped>

</style>